<template>
    <div style="background-color: #f0f6fa;">
        <div style="position: relative;">
            <img src="@/images/agencyBanner.png" style="width: 100vw;height: 30.21vw;">
            <div class="topTitle">
                合作代理
            </div>
            <div class="topText">
                湖南见心科技有限公司作为心理健康领域的领先企业，一直致力于提供科学的心理健康支持。我们深知心理健康对于个人成长和社会发展的重要性，因此我们不断创新，让心理健康服务更加普及与有效。
                我们深信，只有通过广泛的合作才能真正实现心理健康服务的普及化与专业化。为此，我们特别设计了多种合作模式，旨在寻找志同道合的伙伴，共同推动心理健康行业的进步与发展。
            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.5625vw">
                <div style="margin-bottom:0.5208vw;padding-top:3.59375vw;">
                    合作模式
                </div>
                <div style="font-weight: 400;font-size: 0.729vw;color: #7ED0FF;">
                    Cooperation model
                </div>
            </div>
            <div style="margin-top:2.604vw;padding-bottom:2.083vw">
                <div style="position: relative;margin-left:6.8229vw">
                    <img src="@/images/agencyImg1.png" style="width: 66.1458vw;height:7.2917vw;">
                    <div class="boxOneTile">区域代理</div>
                    <div class="boxOneText">
                        ·成为我们在指定区域内的合作伙伴，享有该地区所有产品的销售权。<br>
                        ·获得全面的市场支持，包括但不限于广告宣传、市场调研、技术支持等。
                    </div>
                </div>
                <div style="position: relative;margin-left:6.8229vw;margin-top:1.0417vw">
                    <img src="@/images/agencyImg2.png" style="width: 66.1458vw;height:7.2917vw;">
                    <div class="boxOneTile">联合研发与创新</div>
                    <div class="boxOneText">
                        ·针对特定市场需求，共同开发新的心理健康产品和服务。<br>
                        ·在项目成功后按协议分配利润。

                    </div>
                </div>
                <div style="position: relative;margin-left:6.8229vw;margin-top:1.0417vw">
                    <img src="@/images/agencyImg3.png" style="width: 66.1458vw;height:7.2917vw;">
                    <div class="boxOneTile">服务联盟合作</div>
                    <div class="boxOneText">
                        ·对于已经存在的服务网络，获得心理健康服务的专业支持和技术指导。<br>
                        ·通过合作，提升服务质量，增强市场竞争力。

                    </div>
                </div>
                <div style="position: relative;margin-left:6.8229vw;margin-top:1.0417vw">
                    <img src="@/images/agencyImg4.png" style="width: 66.1458vw;height:7.2917vw;">
                    <div class="boxOneTile">品牌合作与推广</div>
                    <div class="boxOneText" style="top: 3.1771vw;">
                        ·通过品牌推广和品牌联名或共同举办活动等形式，共同扩大品牌影响力 。
                    </div>
                </div>

            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.5625vw">
                <div style="margin-bottom:0.5208vw;padding-top:3.59375vw;">
                    合作优势
                </div>
                <div style="font-weight: 400;font-size: 0.729vw;color: #7ED0FF;">
                    Cooperative advantages
                </div>
            </div>
            <div class="box2Css" style="margin-left: 6.7708vw;margin-right: 6.7708vw;">
                <div class="box2Item" style="margin-right: 1.0417vw;">
                    <img src="@/images/agencyImg5.png" style="width: 4.3229vw;height: 4.9479vw;">
                    <div class="ItemTitle">
                        技术支持
                    </div>
                    <div class="itemText">
                        持续投入研发，确保合作伙伴能够获得最新的心理健康技术支持。
                    </div>
                </div>
                <div class="box2Item" style="margin-right: 1.0417vw;">
                    <img src="@/images/agencyImg6.png" style="width: 4.3229vw;height: 4.9479vw;">
                    <div class="ItemTitle">
                        技术支持
                    </div>
                    <div class="itemText">
                        持续投入研发，确保合作伙伴能够获得最新的心理健康技术支持。
                    </div>
                </div>
                <div class="box2Item" style="margin-right: 1.0417vw;">
                    <img src="@/images/agencyImg7.png" style="width: 4.3229vw;height: 4.9479vw;">
                    <div class="ItemTitle">
                        技术支持
                    </div>
                    <div class="itemText">
                        持续投入研发，确保合作伙伴能够获得最新的心理健康技术支持。
                    </div>
                </div>

            </div>
        </div>
        <div class="boxOne">
            <div class="TitleCss" style="margin-bottom:1.5625vw">
                <div style="margin-bottom:0.5208vw;padding-top:3.59375vw;">
                    合作流程
                </div>
                <div style="font-weight: 400;font-size: 0.729vw;color: #7ED0FF;">
                    Cooperation process
                </div>
            </div>
            <div class="box2Css" style="margin-top:3.125vw">
                <img src="@/images/agencyBox1.png" style="width: 12.5vw;height: 12.5vw;">
                <img src="@/images/agencyRig.png"
                    style="width: 1.9271vw;height: 1.6146vw;margin-left:0.5208vw;margin-right:0.5208vw">
                <img src="@/images/agencyBox2.png" style="width: 12.5vw;height: 12.5vw;">
                <img src="@/images/agencyRig.png"
                    style="width: 1.9271vw;height: 1.6146vw;margin-left:0.5208vw;margin-right:0.5208vw">
                <img src="@/images/agencyBox3.png" style="width: 12.5vw;height: 12.5vw;">
                <img src="@/images/agencyRig.png"
                    style="width: 1.9271vw;height: 1.6146vw;margin-left:0.5208vw;margin-right:0.5208vw">
                <img src="@/images/agencyBox4.png" style="width: 12.5vw;height: 12.5vw;">
            </div>
            <div class="btnOneCss" @click="Togo">
                申请合作
            </div>
        </div>
        <div style="height: 2.604vw;"></div>
    </div>
</template>

<script>
export default {
    name: 'agencyPage',
    data() {
        return {

        }
    },
    methods: {
        Togo() {
            window.location.href = "https://www.foheart.cn";
        }
    }
}
</script>

<style lang="less" scoped>
.boxOne {
    width: 72.9167vw;
    margin: 0 auto;
    min-height: 33.59375vw;
    background: #fff;
    border-radius: 1.0417vw;
    margin-top: 3.2083vw;
}

.TitleCss {
    margin: 0 auto;
    text-align: center;
    // margin-top: 7.4479vw;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.875vw;
    color: #0093E8;
}

.jianxinCss {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 0.9375vw;
    color: #666666;
    line-height: 1.875vw;
    margin-bottom: 5.2083vw;
    flex-wrap: wrap;
    padding-bottom: 1.0417vw;
}

.box2Css {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

}

.btnOneCss {
    width: 18.3333vw;
    height: 3.6458vw;
    background: #0093E8;
    border-radius: 1.8229vw 1.8229vw 1.8229vw 1.8229vw;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.4583vw;
    color: #FFFFFF;
    text-align: center;
    line-height: 3.6458vw;
    margin: 0 auto;
    margin-top: 2.6042vw;
    margin-bottom: 1.5625vw;
    cursor: pointer;

    &:hover {
        background: #EBBAD5;
    }
}

.topTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.875vw;
    color: #0093E8;
    // line-height: 7.2917vw;
    position: absolute;
    left: 17.0833vw;
    top: 8.6458vw;
}

.topText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 1.0417vw;
    color: #666666;
    line-height: 1.875vw;
    text-align: justifyLeft;
    font-style: normal;
    text-transform: none;
    position: absolute;
    left: 17.0833vw;
    top: 11.875vw;
    width: 39.74vw;
}

.boxOneTile {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.4583vw;
    color: #444444;
    position: absolute;
    left: 8.28125vw;
    top: 2.8646vw;
}

.boxOneText {
    position: absolute;
    left: 21.6146vw;
    top: 2.03125vw;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 1.0417vw;
    color: #666666;
    line-height: 1.6667vw;
}

.box2Item {
    width: 18.6458vw;
    height: 19.375vw;
    background: radial-gradient(#FFFFFF 0%, #F4FBFF 100%);
    border-radius: 1.0417vw 1.0417vw 1.0417vw 1.0417vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

}

.ItemTitle {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: bold;
    font-size: 1.4583vw;
    color: #444444;
    margin-top: 1.875vw;
    margin-bottom: 2.03125vw;
}

.itemText {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 0.9896vw;
    color: #666666;
    width: 15.1042vw;
    line-height: 1.875vw;
}
</style>